import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import React, { lazy, Suspense } from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import ErrorHandler from './core/modules/ErrorHandler';
import reducers from './core/reducers';
import { getEnvVariable } from "./modules/environmentalList";
import { theme, apps_theme, apps_theme_custom, wrs_theme, mps_theme,shapes_theme } from './styles/material-theme';

import background from './images/FORWARDLanding.jpg'
import { getSignInToken } from './core/modules/header';
const store = createStore(reducers, applyMiddleware(thunk));

function component(id, classes) {
    var element = document.createElement('div');
    element.setAttribute("id", id);
    classes.forEach(e => element.classList.add(e))
    return element;
};

function GetApp(moduleKey) {
    if (moduleKey === 'MPS')
        return lazy(() => import('./app/App_MPS'))
    if (moduleKey === 'SHAPES')
        return lazy(() => import('./app/App_SHAPES'))
    if (moduleKey === 'APPS')
        return lazy(() => import('./app/App_APPS'))
}

function GetTheme(moduleKey) {
    // Check if custom theme should be applied based on condition
    if (getEnvVariable("ModuleKey") === 'APPS' && getEnvVariable("Port") === '8553') {
        return apps_theme_custom;
    }
    
    if (moduleKey === 'AMES')
        return theme
    else if (moduleKey === 'WRS' )//|| moduleKey === 'MPS'
        return wrs_theme
    else if (moduleKey === 'MPS')
        return mps_theme
    else if (moduleKey === 'APPS')
        return apps_theme
    else if (moduleKey === 'SHAPES')
        return shapes_theme
    else return theme
}

const MaterialTheme = GetTheme(getEnvVariable('ModuleKey'))
const App = GetApp(getEnvVariable('ModuleKey'));


document.body.appendChild(component('ames-backdrop', ['ames-class']));
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <MuiThemeProvider theme={MaterialTheme}>
        <CssBaseline>        
            <ErrorHandler>
                <Provider store={store}>
                    <Suspense fallback={<div ></div>}>
                        <App />
                    </Suspense>
                </Provider>
            </ErrorHandler>
        </CssBaseline>
    </MuiThemeProvider>
);



